export enum LeadAbleType {
  call_history = "call_history",
  ticket = "ticket",
  partner = "partner",
}
